const namespace = 'PPO';

export const REQUEST_ORGANIZATION = `${namespace}/REQUEST_ORGANIZATION`;
export const RECEIVE_ORGANIZATION_SUCCESS = `${namespace}/RECEIVE_ORGANIZATION_SUCCESS`;
export const RECEIVE_ORGANIZATION_FAILURE = `${namespace}/RECEIVE_ORGANIZATION_FAILURE`;

export const RECEIVE_ORGANIZATIONS_SUCCESS = `${namespace}/RECEIVE_ORGANIZATIONS_SUCCESS`;
